import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { IUserElevatorIntegration } from '../../api/elevatorIntegrationTS';
import messages from './messages';

function ElevatorIntegrationSwitchSettings({
  currentSettings,
  onElevatorIntegrationSet,
}: {
  onElevatorIntegrationSet: (landingCall: boolean, destinationCall: boolean) => void;
  currentSettings: IUserElevatorIntegration | undefined;
}) {
  const { formatMessage } = useIntl();
  const landingCall = !!currentSettings?.landingCallEnabled;
  const destinationCall = !!currentSettings?.destinationCallEnabled;

  const handleLandingCallChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLandingCall = event.target.checked;
    onElevatorIntegrationSet(newLandingCall, newLandingCall ? destinationCall : false);
  };

  const handleDestinationCallChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDestinationCall = event.target.checked;
    onElevatorIntegrationSet(landingCall, newDestinationCall);
  };

  return (
    <Stack alignItems="flex-start" direction={{ sm: 'row', xs: 'column' }} sx={{ mt: -1 }}>
      <FormControlLabel
        slotProps={{
          typography: {
            variant: 'body1',
          },
        }}
        control={<Switch checked={landingCall} onChange={handleLandingCallChange} />}
        label={formatMessage(messages.elevatorIntegrationSettingsLandingCall)}
      />
      <FormControlLabel
        slotProps={{
          typography: {
            variant: 'body1',
          },
        }}
        disabled={!currentSettings?.landingCallEnabled}
        control={<Switch checked={destinationCall} onChange={handleDestinationCallChange} />}
        label={formatMessage(messages.elevatorIntegrationSettingsDestinationCall)}
      />
    </Stack>
  );
}

export default ElevatorIntegrationSwitchSettings;
